import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
declare var jslib;
declare var tippy;
@Component({
  selector: 'mybuyer-component',
  templateUrl: './mybuyer.component.html'
})
export class MybuyerComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    var urlParam = this.jslib.UrlParam();
    if(urlParam && urlParam['page']){
      var pn = Number(urlParam['page']);
      if(pn > 0){
        this.Query.pageNumber = pn;
      }
    }
    this.GetOption();//買主產業與所在地搜尋選項
    this.TagAddFilter();
    this.Submit();
  }

  public Query = {
    pageNumber:1,
    pageSize:10,
    industry_id:'',//產業代碼
    country_ids:'',//買主所在地
    company_name:'',//買主公司
    keyword:'',//採購品項
    buyer_status:'',//買主狀態
    hideCanceledBuyers: false //隱藏取消來台買主
  };
  public Countries = [];
  public Industries = [];
  public OptionReady = false;
  GetOption(){
    this.OptionReady = false;
    this.baseApi.apiGet('v1/member/favoriteBuyersAsset',{}).then(
      (res)=>{
        if(res != null){
          this.Countries = res['countries'];
          this.Industries = res['industries'];
        }
        this.OptionReady = true;
      });
  }
  public Data;
  public Pager;
  Submit(){
    this.QueryHandle();
    this.baseApi.apiGet('v1/member/favoriteBuyers',this.Query).then(
      (res)=>{
        //console.log('favoriteBuyers',res);
        if(res){
          this.Data = res['data'];
          this.Pager = res['pager'];
          this.RenderTagHover();
        }
      });
  }
  QueryHandle(){
    this.Query.country_ids = '';
    this.TagList.forEach(_item => {
      //報名狀態
      // if(_item['main'] == 0){
      //   this.Query.event_status = _item['select'];
      // }
      //產業
      if(_item['main'] == 1){
        this.Query.industry_id = _item['select'];
      };
      //採購案類型
      // if(_item['main'] == 2){
      //   this.Query.event_type = _item['select'];
      // }
      //買主所在地
      if(_item['main'] == 3){
        if(_item['select'] == 'continental'){
          //this.Query.continental = _item['name'];//處理州別
        }else{
          if(this.Query.country_ids != ''){
            this.Query.country_ids = this.Query.country_ids + ',' +_item['select'];
          }else{
            this.Query.country_ids = _item['select'];
          }
        }
      }
      //買主公司
      if(_item['main'] == 4){
        this.Query.company_name = _item['select'];
      }
      //採購品項
      if(_item['main'] == 5){
        this.Query.keyword = _item['select'];
      }
      //買主預約狀態
      if(_item['main'] == 6){
        this.Query.buyer_status = _item['select'];
      }
    });
  }
  SetPage(index){
    this.Query.pageNumber = index;
    this.Submit();
  }

  public tempBuyerQuery = {main:1,select:'',name:''};
  BuyerTemp(event){
    //console.log('BuyerTemp',event);
    this.tempBuyerQuery = event;
  }
  BuyerEvt(evt){
    var _checked = evt.target.checked;
    this.Query.hideCanceledBuyers = _checked;
    this.Submit();
  }

  public TagList = [];
  AddToTag(){
    //console.log('this.tempBuyerQuery',this.tempBuyerQuery)
    if(this.tempBuyerQuery.select != ''){
      var isExist = this.TagList.find(item =>{
        return (item.main == this.tempBuyerQuery.main);
      });

      if(typeof isExist == 'undefined'){
        var _item = JSON.parse(JSON.stringify(this.tempBuyerQuery));
        this.TagList.push(_item);
        this.Submit();
      }else{
        var _item = JSON.parse(JSON.stringify(this.tempBuyerQuery));
        //買主所在地條件為累加 其餘為覆蓋
        if(_item['main'] == 3){
          var _isExist = this.TagList.findIndex((_select)=>{
            return _select['select'] == _item['select'];
          });
          if(_isExist == -1){
            this.TagList.push(_item);
          }
        }else{
          isExist.select = this.tempBuyerQuery.select;
          isExist.name = this.tempBuyerQuery.name;
        }
        this.Submit();
      }
    }
    this.TagRender();
  }

  TagGroup = [];
  TagRender(){
    //拿Search結構來改
    this.TagGroup = this.config.Search;
    this.TagGroup.forEach(g => {
      g['tag'] = [];
    });
    if(this.TagList && this.TagList.length > 0){
      var m = this.config.Search;
      this.TagList.forEach((tag,tag_index) => {
        tag['tag_index'] = tag_index;
        var _index = m.findIndex((_item)=>{return _item['value'] == tag['main']});
        if(_index > -1){
          this.TagGroup[_index]['tag'].push(tag);
        }
      });
    }
  }

  RemoveTag(index){
    this.TagList.splice(index, 1);
    //reset
    var _hideBuyers = this.Query.hideCanceledBuyers;
    this.Query = {
      pageNumber:1,
      pageSize:10,
      industry_id:'',
      country_ids:'',
      company_name:'',
      keyword:'',
      buyer_status:'',
      hideCanceledBuyers: _hideBuyers
    };
    this.Submit();
    this.TagRender();
  }

  RenderTagHover(){
    setTimeout(()=>{
      this.ngzone.runOutsideAngular(()=>{

        window['tag_tip'] = 
          tippy('.hoverEvt span', {
            content: 'Loading...',
            theme:'tag',
            //trigger: 'click',
            allowHTML: true,
            interactive: true,
            onShow(instance) {
                var dom = instance['reference'];
                var param = {
                  txt : dom.innerText,
                  desc : dom.dataset.desc,
                  spec : dom.dataset.spec,
                  attach : dom.dataset.attach,
                  pid : dom.dataset.pid,
                  buyer : dom.dataset.buyer,
                  islogin : false
                };
                param.islogin = jslib.GetStorage('user') != null;
                ////console.log('instance param',param);
                var html = '<div class="tag_pop">';
                html += '<label>' +  param.txt + '</label>';
                
                //尚未登入顯示
                if(param.spec == 'false' && param.islogin == false){
                  html += '<p>登入查看詳細規格</p>';
                  html += '<div class="bottom"><span></span><span class="add" onclick="ToLogIn()"><i class="lock"></i>立即登入</span></div>';
                }else{
                  html += '<p>' + param.desc +  '</p>';
                  if(param.attach == 'true' && param.islogin){
                    var _url = '/brochure/download?buyer_id=' + param.buyer + '&product_id=' + param.pid;
                    html += '<div class="bottom"><span><i class="icon icon-attach-file">&#xe80a;</i><a href="' + _url + '" target="_blank">下載檔案</a></span><span class="add" onclick="AddProd(\'' + param.txt + '\')">加入搜尋條件</span></div>';
                  }else{
                    html += '<div class="bottom"><span></span><span class="add" onclick="AddProd(\'' + param.txt + '\')">加入搜尋條件</span></div>';
                  }
                  html += '</div>';
                }

                instance.setContent(html);
              },
          });

      });
    },250);
  }
  TagAddFilter(){
    window['AddProd'] = (keyword)=>{
      //console.log('AddProd',keyword);
      var _temp = {main:5,select:keyword,name:keyword};
     

      this.ngzone.run(()=>{
        var isExist = this.TagList.find(item =>{
          return (item.main == _temp.main);
        });
        if(typeof isExist == 'undefined'){
          var _item = JSON.parse(JSON.stringify(_temp));
          this.TagList.push(_item);
          this.Submit();
          this.TagRender();
          
        }else{
          var _item = JSON.parse(JSON.stringify(_temp));
          isExist.select = _temp.select;
          isExist.name = _temp.name;
          this.Submit();
          this.TagRender();
        }
      });
    };
    window['ToLogIn'] = ()=>{
      this.baseApi.RedirectSSO();
    }
  }
}
